<template>
  <CardCollapse class="assets-form" :icon="icon" :isValid="isValid" :title="name" :isOpen="isOpen">
    <template slot="action">
      <el-popover placement="left" v-model="visibleRemoveSet">
        <el-button icon="el-icon-delete" type="text" @click="removeSet">Remove set</el-button>

        <el-button slot="reference" type="text" class="p-1" icon="el-icon-more"></el-button>
      </el-popover>
    </template>
    <ElForm :model="assets" :rules="rules" ref="localForm" @submit.prevent.native>
      <div class="text-13px font-bold pb-1"><span class="text-danger">*</span> Media</div>
      <ElFormItem prop="link">
        <p>Add media that will be used to generate Social Boost creatives.</p>
        <!-- link -->
        <div class="mt-1">
          <el-radio class="mb-1" v-model="mediaType" label="link">Link a post</el-radio>
          <ElInput
            v-model="assets.link"
            :disabled="mediaType !== 'link'"
            placeholder="Enter URL"
            :maxlength="100"
            minlength="3"
            @input="emitInputChange"
          />
        </div>
        <!-- end link -->
      </ElFormItem>
      <div class="my-2 w-full text-center text-grayDark">or</div>
      <ElFormItem>
        <el-radio class="mb-1" v-model="mediaType" label="upload">Upload media file</el-radio>

        <UploadFiles
          ref="uploadFile"
          :disabled="mediaType !== 'upload'"
          :options="{ limit: 100 }"
          v-model="assets.files"
          @change="emitInputChange"
          @remove="removeFile"
        >
          <template slot="tip">Only JPG, PNG, MP4, AVI, and MOV files under 5MB per file are supported.</template>
        </UploadFiles>
      </ElFormItem>
      <div class="text-13px font-bold pb-1">
        <!-- <span class="text-danger">*</span>  -->
        Call to Action
      </div>
      <p>Enter the URL where users will be directed after clicking on Social Boost creatives.</p>
      <!-- cta color -->
      <ElFormItem prop="ctaColor">
        <div class="mt-1">
          <label for="ctaColor" class="text-13px font-bold text-grayNeutralDark">CTA color</label>
          <ElInput class="mt-1" v-model="assets.ctaColor" placeholder="#ffffff" :maxlength="100" minlength="3" @input="emitInputChange">
            <template slot="prepend"
              ><el-color-picker class="colorPiker" v-model="assets.ctaColor" @change="emitInputChange"></el-color-picker
            ></template>
          </ElInput>
        </div>
      </ElFormItem>
      <!-- end cta color -->
      <!-- cta text -->
      <ElFormItem prop="ctaText">
        <div class="mt-1">
          <label for="ctaColor" class="text-13px font-bold text-grayNeutralDark">CTA text</label>
          <ElInput
            class="mt-1"
            v-model="assets.ctaText"
            placeholder="Ex. Discover more"
            show-word-limit
            :maxlength="30"
            @input="emitInputChange"
          />
        </div>
      </ElFormItem>
      <!-- end cta text -->
      <!-- cta text -->
      <ElFormItem prop="landingPage">
        <span slot="label">Landing page</span>
        <p>Enter the URL where users will be directed after clicking on Social Boost creatives.</p>
        <ElInput class="mt-1" v-model="assets.landingPage" placeholder="Enter URL" @input="emitInputChange" />
      </ElFormItem>
      <!-- end cta text -->
      <ElFormItem>
        <span slot="label">Tracking tags (Optional)</span>
        <p class="w-full">Add tracking tags to track the performance of creatives.</p>
        <UploadFiles
          v-model="assets.trackingTagsFiles"
          @change="emitInputChange"
          :validate="false"
          :options="{
            limit: 100,
            accept: [
              'application/zip',
              'application/x-zip-compressed',
              'application/x-zip',
              'application/x-compressed',
              'application/x-compressed',
              'multipart/x-zip',
              'application/vnd.ms-excel',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ],
          }"
          @remove="removeFile"
        >
          <template slot="tip">ZIP/XLS/XLSX files with a maximum size of 5MB per file.</template>
        </UploadFiles>
      </ElFormItem>
    </ElForm>
  </CardCollapse>
</template>
<script>
import Vue from 'vue'
import { ColorPicker, Popover } from 'element-ui'
import CardCollapse from '@/components/social-products/social-boost/parts/CardCollapse.vue'
import UploadFiles from '../parts/UploadFiles.vue'

Vue.use(ColorPicker)
Vue.use(Popover)

export default {
  name: 'AssetItem',
  components: {
    CardCollapse,
    UploadFiles,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visibleRemoveSet: false,
      assets: { ...this.value },
      isValid: true,
      mediaType: this.value?.mediaType || 'link',
      rules: {
        link: [
          {
            required: true,
            message: 'Please enter a link',
            trigger: 'blur',
          },
          {
            type: 'url',
            message: 'URL must follow a valid format (e.g., starting with http:// or https://).',
            trigger: 'blur',
          },
        ],
        ctaColor: [
          {
            required: false,
            message: 'Please enter a call to action color',
            trigger: ['blur', 'change'],
          },
          {
            pattern: /^#[0-9A-Fa-f]{6}$/,
            message: 'Please enter a valid hex color code (e.g., #FFFFFF).',
            trigger: ['blur', 'change'],
          },
        ],
        ctaText: [
          {
            required: false,
            message: 'Please enter a text for the call to action',
            trigger: 'blur',
          },
          {
            max: 30,
            message: 'CTA copy cannot exceed 30 characters.',
            trigger: ['blur'],
          },
        ],
        landingPage: [
          {
            required: true,
            message: 'Please enter a valid URL.',
            trigger: 'blur',
          },
          {
            type: 'url',
            message: 'URL must follow a valid format (e.g., starting with http:// or https://).',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    const value = this.value?.mediaType || 'link'
    this.rules.link[0].required = value === 'link'
  },
  watch: {
    value: {
      handler(newValue) {
        this.assets = { ...newValue }
        //this.$refs.localForm.validate((value) => (this.isValid = value))
      },
      deep: true,
    },
    mediaType: {
      handler(value) {
        this.assets.mediaType = value
        if (value === 'link') {
          this.assets.files = []
        }
        if (value === 'upload') {
          this.assets.link = ''
        }
        this.emitInputChange()
        this.rules.link[0].required = value === 'link'
        this.$refs.localForm.clearValidate('link')
      },
    },
  },
  methods: {
    removeFile(file) {
      console.log('assetsItem', file)
      if (file?.id) {
        this.$store.commit('socialBoostCampaign/SET_DELETE_FILE_FORM', file?.id)
      }
    },
    emitInputChange() {
      this.$emit('input', this.assets)
    },
    validate(callback) {
      const isValid = this.$refs.uploadFile.validateUploadField()
      this.$refs.localForm.validate((valid) => {
        if (callback) {
          this.isValid = valid && isValid
          callback(valid)
        }
        return valid
      })
    },
    validateUploadFile() {
      const isValid = this.$refs.uploadFile.validateUploadField()
      return isValid
    },
    removeSet() {
      this.$emit('remove')
      this.visibleRemoveSet = false
    },
  },
}
</script>
<style lang="scss">
.assets-form {
  .colorPiker {
    .el-color-picker {
      @apply bg-white;
    }
    .el-color-picker__trigger {
      @apply border-r-0 rounded-r-none;
    }
    .el-color-picker__icon {
      @apply text-grayLightest;
    }

    .el-icon-close:before {
      content: '\e6df';
    }
    .el-color-picker__color {
      @apply border-0;
    }
  }
  .el-input-group__prepend {
    @apply bg-transparent border-0 p-0;
  }
}
</style>
